import CloseButton from '../../../shared/CloseButton';

import type { CreateDrawerProps } from './createDrawer.types';
import { DrawerLeaf } from './DrawerLeaf';

export function DrawerHeader({
  title,
  eyebrow,
  quote,
  attribution,
  headerColor,
  onClose,
}: Pick<
  CreateDrawerProps,
  'title' | 'eyebrow' | 'quote' | 'attribution' | 'headerColor' | 'onClose'
>) {
  return (
    <header className="nb-cdrawer-hd" style={{ background: headerColor }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
        <div style={{ flex: 1 }}>
          {eyebrow && <div className="nb-cdrawer-eyebrow">{eyebrow}</div>}
          <h2 className="nb-cdrawer-title">{title}</h2>
        </div>
        {onClose !== null && onClose !== undefined && (
          <CloseButton
            onClick={onClose}
            // On the solid (clay) header band the control sits on a dark bg —
            // use a translucent-white border + white glyph for contrast.
            style={{ border: '1px solid rgba(255,255,255,.45)', color: '#fff' }}
          />
        )}
      </div>
      {quote && (
        <div className="nb-cdrawer-quote">
          <span style={{ color: 'var(--nb-leaf)', flex: '0 0 16px', marginTop: 2 }}>
            <DrawerLeaf size={16} />
          </span>
          <div>
            <div className="nb-cdrawer-quote-text">{`“${quote}”`}</div>
            {attribution && <div className="nb-cdrawer-quote-attr">{attribution}</div>}
          </div>
        </div>
      )}
    </header>
  );
}

// Vertical gap between step rows (the rendered flex-column gap). The connecting
// line's geometry is measured from the real node centers (see useRailLineGeometry).
